<medrecord-ui-select [items]="timepickerList"
                     [placeholder]="watermark"
                     [formControlName]="controlName"
                     class="medrecord-timepicker">